import { InputBoolean } from './input-boolean';
import { InputTriCheck } from './input-tri-check';

let registered = false;

function safeRegister(name: string, constructor: CustomElementConstructor) {
  try {
    customElements.define(name, constructor);
  } catch {
    console.log(`customElement "${name}" already registered`);
  }
}

function prefixName(name: string, prefix?: string): string {
  if (prefix) prefix += '-';
  else prefix = 'webmodule-';
  return `${prefix}${name}`;
}

declare global {
  interface HTMLElementTagNameMap {
    'webmodule-input-boolean': InputBoolean;
    'webmodule-input-tricheck': InputTriCheck;
  }
}

export function registerComponentsLocal(prefix?: string) {
  if (!registered) {
    safeRegister(prefixName('input-boolean', prefix), InputBoolean);
    safeRegister(prefixName('input-tricheck', prefix), InputTriCheck);
    registered = true;
  }
  /* plop:component */
}
